/**
 * Multi-number (2026-10): "All numbers" / one-number filter for the Inbox rail. Renders nothing
 * unless the open workspace is a workspace with more than one QR number on an account where QR is enabled, so single-number and Meta-only workspaces never see it.
 */
import React from "react";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setConnectionFilter } from "../../redux/Slice/Inbox/inboxRecentSlice";

const ALL = "all";

const InboxNumberFilter = () => {
  const dispatch = useDispatch();
  const connections = useSelector((state) => state.workspace?.currentWorkspace?.whatsappQrConnections);
  const selected = useSelector((state) => state.inboxRecent?.selectedConnectionId);
  // Only for accounts staff enabled for QR (an account disabled later keeps its chats readable, just without this control).
  const qrEnabled = useSelector((state) => Boolean(state.workspace?.currentWorkspace?.qrPilotEnabled));

  if (!qrEnabled || !Array.isArray(connections) || connections.length < 2) return null;

  return (
    <Box sx={{ px: 1.5, pt: 1, pb: 0.5 }}>
      <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 0.5 }}>
        WhatsApp number
      </Typography>
      <Select
        size="small"
        fullWidth
        value={selected || ALL}
        onChange={(e) => dispatch(setConnectionFilter(e.target.value === ALL ? null : e.target.value))}
        inputProps={{ "aria-label": "Filter inbox by WhatsApp number" }}
        sx={{ fontSize: "0.875rem" }}
      >
        <MenuItem value={ALL}>All numbers</MenuItem>
        {connections.map((c) => (
          <MenuItem key={c.connectionId} value={c.connectionId}>
            {c.label || c.phoneNumber || `Number ${c.slot + 1}`}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default InboxNumberFilter;
